(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-faq-guide"]) return;
  try {
    
  (() => {
    const root = document.querySelector('.article-faq-guide');
    if (!root) return;

    const input = root.querySelector('[data-article-faq-guide-search]');
    const items = root.querySelectorAll('[data-article-faq-guide-item]');
    const empty = root.querySelector('[data-article-faq-guide-empty]');
    if (!input || !items.length || !empty) return;

    const filterItems = () => {
      const keyword = (input.value || '').trim().toLowerCase();
      let visibleCount = 0;

      items.forEach((item) => {
        const text = item.getAttribute('data-search-text') || '';
        const show = keyword == '' || text.includes(keyword);
        item.hidden = !show;
        if (show) visibleCount += 1;
      });

      empty.hidden = visibleCount !== 0;
    };

    input.addEventListener('input', filterItems);
    filterItems();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const details = document.querySelectorAll('.accordion');

    function toggleDetails() {
      details.forEach((el) => {
        if (window.innerWidth <= 900) {
          el.removeAttribute('open');
        } else {
          el.setAttribute('open', '');
        }
      });
    }

    toggleDetails();
    window.addEventListener('resize', toggleDetails);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const menuToggle = document.getElementById('sp-menu-toggle');
    const menuLinks = document.querySelectorAll('.sp-hamburger-menu a');
    const header = document.querySelector('header');
    const headerSpacer = document.querySelector('[data-header-spacer]');
    const cartDrawer = document.querySelector('[data-cart-drawer]');
    const cartOpenButtons = document.querySelectorAll('[data-cart-drawer-open]');
    const cartCloseButtons = document.querySelectorAll('[data-cart-drawer-close]');
    const cartDrawerContent = cartDrawer ? cartDrawer.querySelector('[data-cart-drawer-content]') : null;
    const cartCountNodes = document.querySelectorAll('[data-cart-count]');
    const cartDotNodes = document.querySelectorAll('[data-cart-dot-badge]');
    let lastScrollY = window.scrollY || window.pageYOffset;
    const minScrollY = 80;
    const minDelta = 6;

    if (!header) return;

    const moneyFormat = cartDrawer ? cartDrawer.dataset.moneyFormat : '';
    const currencyCode = cartDrawer ? cartDrawer.dataset.currencyCode : 'JPY';
    const cartUrl = cartDrawer && cartDrawer.dataset.cartUrl ? cartDrawer.dataset.cartUrl : '/cart';

    const syncHeaderSpacer = () => {
      if (!header || !headerSpacer) return;
      const height = header.getBoundingClientRect().height;
      headerSpacer.style.setProperty('--header-height', `${height}px`);
    };

    const lockScroll = () => {
      if (document.body.classList.contains('sp-menu-open')) return;
      const scrollY = window.scrollY || window.pageYOffset;
      document.body.dataset.spMenuScrollY = String(scrollY);
      document.body.classList.add('sp-menu-open');
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    };

    const unlockScroll = () => {
      if (!document.body.classList.contains('sp-menu-open')) return;
      const scrollY = Number(document.body.dataset.spMenuScrollY || 0);
      document.body.classList.remove('sp-menu-open');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      delete document.body.dataset.spMenuScrollY;
      window.scrollTo(0, scrollY);
    };

    const isMenuOpen = () => {
      if (!menuToggle) return false;
      return menuToggle.checked;
    };

    const isCartOpen = () => {
      if (!cartDrawer) return false;
      return cartDrawer.classList.contains('is-open');
    };

    const syncLockState = () => {
      if (isMenuOpen()) {
        lockScroll();
        return;
      }

      if (isCartOpen()) {
        lockScroll();
        return;
      }

      unlockScroll();
    };

    const escapeHtml = (value) => {
      if (typeof value != 'string') return '';
      return value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    };

    const formatMoney = (cents) => {
      if (window.Shopify && typeof window.Shopify.formatMoney == 'function' && moneyFormat) {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }
      return new Intl.NumberFormat(document.documentElement.lang || 'ja', {
        style: 'currency',
        currency: currencyCode || 'JPY',
      }).format((Number(cents) || 0) / 100);
    };

    const normalizeImageUrl = (item) => {
      const source = item.featured_image || item.image;
      if (!source) return '';
      if (typeof source == 'string') {
        if (source.startsWith('//')) return `https:${source}`;
        return source;
      }
      if (source.url) {
        if (source.url.startsWith('//')) return `https:${source.url}`;
        return source.url;
      }
      return '';
    };

    const updateCartIndicators = (cart) => {
      const count = Number(cart.item_count) || 0;
      cartCountNodes.forEach((node) => {
        node.textContent = String(count);
      });
      cartDotNodes.forEach((node) => {
        node.classList.toggle('is-hidden', count <= 0);
      });
    };

    const renderCartDrawerContent = (cart) => {
      if (!cartDrawerContent) return;

      if (!cart || !cart.items || cart.items.length === 0) {
        cartDrawerContent.innerHTML = `
          <div class="header-cart-drawer__empty">
            <p>カートに商品がありません。</p>
            <a href="/collections/all">商品を探す</a>
          </div>
        `;
        return;
      }

      const itemsHtml = cart.items
        .map((item, index) => {
          const imageUrl = normalizeImageUrl(item);
          const productUrl = item.url || '#';
          const title = escapeHtml(item.product_title || item.title || '');
          const variantTitle =
            item.variant_title && item.variant_title != 'Default Title'
              ? `<p class="header-cart-drawer__variant">${escapeHtml(item.variant_title)}</p>`
              : '';
          const removeUrl = `/cart/change?line=${index + 1}&quantity=0`;
          const imageHtml = imageUrl
            ? `<a href="${productUrl}"><img class="header-cart-drawer__image" src="${imageUrl}" alt="${title}" loading="lazy"></a>`
            : '<div class="header-cart-drawer__image header-cart-drawer__image--placeholder" aria-hidden="true"></div>';

          return `
            <li class="header-cart-drawer__item">
              <div class="header-cart-drawer__image-wrap">${imageHtml}</div>
              <div class="header-cart-drawer__content">
                <p class="header-cart-drawer__item-title"><a href="${productUrl}">${title}</a></p>
                ${variantTitle}
                <p class="header-cart-drawer__qty">数量: ${item.quantity}</p>
                <p class="header-cart-drawer__price">${formatMoney(item.final_line_price)}</p>
                <a class="header-cart-drawer__remove" href="${removeUrl}" data-cart-remove data-line="${
            index + 1
          }">削除</a>
              </div>
            </li>
          `;
        })
        .join('');

      cartDrawerContent.innerHTML = `
        <ul class="header-cart-drawer__list" role="list">${itemsHtml}</ul>
        <div class="header-cart-drawer__footer">
          <p class="header-cart-drawer__total">
            <span>合計</span>
            <strong>${formatMoney(cart.total_price)}</strong>
          </p>
          <form action="${cartUrl}" method="post">
            <button class="header-cart-drawer__checkout" type="submit" name="checkout">購入手続きへ</button>
          </form>
        </div>
      `;
    };

    const fetchCart = async () => {
      const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Failed to fetch cart');
      return response.json();
    };

    const removeCartLine = async (line) => {
      const lineNumber = Number(line);
      if (!lineNumber) throw new Error('Invalid line');
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ line: lineNumber, quantity: 0 }),
      });
      if (!response.ok) throw new Error('Failed to remove cart line');
      return response.json();
    };

    const refreshCartDrawer = async () => {
      if (!cartDrawer) return;
      const cart = await fetchCart();
      updateCartIndicators(cart);
      renderCartDrawerContent(cart);
    };

    const closeCartDrawer = () => {
      if (!cartDrawer) return;
      cartDrawer.classList.remove('is-open');
      cartDrawer.setAttribute('aria-hidden', 'true');
      syncLockState();
    };

    const openCartDrawer = async (options = {}) => {
      if (!cartDrawer) return;
      if (options.refresh) {
        try {
          await refreshCartDrawer();
        } catch (error) {}
      }
      cartDrawer.classList.add('is-open');
      cartDrawer.setAttribute('aria-hidden', 'false');
      syncLockState();
    };

    if (menuToggle) {
      menuToggle.addEventListener('change', syncLockState);
    }

    cartOpenButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        openCartDrawer({ refresh: true });
      });
    });

    cartCloseButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        closeCartDrawer();
      });
    });

    if (cartDrawerContent) {
      cartDrawerContent.addEventListener('click', async (event) => {
        const removeLink = event.target.closest('[data-cart-remove]');
        if (!removeLink) return;

        event.preventDefault();

        const line = removeLink.getAttribute('data-line');
        if (!line) return;

        removeLink.setAttribute('aria-disabled', 'true');
        removeLink.style.pointerEvents = 'none';

        try {
          const cart = await removeCartLine(line);
          updateCartIndicators(cart);
          renderCartDrawerContent(cart);
        } catch (error) {
          window.location.href = cartUrl;
        }
      });
    }

    menuLinks.forEach((link) => {
      link.addEventListener('click', () => {
        if (!menuToggle) return;
        menuToggle.checked = false;
        syncLockState();
      });
    });

    window.addEventListener('resize', () => {
      syncHeaderSpacer();
      if (!menuToggle) return;
      if (window.innerWidth > 1000 && menuToggle.checked) {
        menuToggle.checked = false;
        syncLockState();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key != 'Escape') return;

      if (isCartOpen()) {
        closeCartDrawer();
      }

      if (isMenuOpen()) {
        if (!menuToggle) return;
        menuToggle.checked = false;
        syncLockState();
      }
    });

    document.addEventListener('cart:open', () => {
      openCartDrawer({ refresh: true });
    });

    window.MocktailCartDrawer = {
      open: () => openCartDrawer({ refresh: true }),
      close: closeCartDrawer,
      refresh: refreshCartDrawer,
    };

    const handleHeaderVisibility = () => {
      if (isMenuOpen()) {
        header.classList.remove('is-hidden');
        return;
      }

      if (isCartOpen()) {
        header.classList.remove('is-hidden');
        return;
      }

      const currentY = window.scrollY || window.pageYOffset;

      if (currentY <= minScrollY) {
        header.classList.remove('is-hidden');
        lastScrollY = currentY;
        return;
      }

      if (currentY > lastScrollY + minDelta) {
        header.classList.add('is-hidden');
      } else if (currentY < lastScrollY - minDelta) {
        header.classList.remove('is-hidden');
      }

      lastScrollY = currentY;
    };

    window.addEventListener('scroll', handleHeaderVisibility, { passive: true });
    syncHeaderSpacer();
    syncLockState();
    handleHeaderVisibility();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hello-world"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const slideshows = document.querySelectorAll('.hw-slideshow');

    slideshows.forEach((slideshow) => {
      const viewport = slideshow.querySelector('.hw-slideshow__viewport');
      const track = slideshow.querySelector('.hw-slideshow__track');
      if (!viewport || !track) return;

      const originalSlides = Array.from(track.querySelectorAll('.hw-slideshow__slide'));
      const prev = slideshow.querySelector('.hw-slideshow__arrow--prev');
      const next = slideshow.querySelector('.hw-slideshow__arrow--next');
      const dots = slideshow.querySelectorAll('.hw-slideshow__dot');
      const total = originalSlides.length;

      if (total < 2) return;

      const leftClones = originalSlides.map((slide) => {
        const clone = slide.cloneNode(true);
        clone.setAttribute('data-clone', 'true');
        return clone;
      });
      const rightClones = originalSlides.map((slide) => {
        const clone = slide.cloneNode(true);
        clone.setAttribute('data-clone', 'true');
        return clone;
      });

      leftClones
        .slice()
        .reverse()
        .forEach((clone) => {
          track.insertBefore(clone, track.firstChild);
        });
      rightClones.forEach((clone) => {
        track.appendChild(clone);
      });

      let slides = Array.from(track.querySelectorAll('.hw-slideshow__slide'));
      let index = total;
      let logicalIndex = 0;
      let isTransitioning = false;
      let timer = null;
      const shouldAutoplay = slideshow.dataset.autoplay === 'true';
      const interval = Number(slideshow.dataset.interval) || 5000;
      const canHoverActivate = window.matchMedia('(hover: hover)').matches;
      let isMobile = window.innerWidth <= 1000;

      const shouldAutoplayNow = () => {
        return isMobile || shouldAutoplay;
      };

      const getLogicalIndexFromRendered = (renderedIndex) => {
        return ((renderedIndex % total) + total) % total;
      };

      const update = (animate = true) => {
        const activeSlide = slides[index];
        if (!activeSlide) return;

        if (animate) {
          slideshow.classList.remove('is-resetting');
          track.style.transition = 'transform 0.45s ease';
        } else {
          slideshow.classList.add('is-resetting');
          track.style.transition = 'none';
        }

        const targetCenter = activeSlide.offsetLeft + activeSlide.offsetWidth / 2;
        const viewportCenter = viewport.clientWidth / 2;
        const targetTranslate = targetCenter - viewportCenter;

        track.style.transform = `translateX(-${targetTranslate}px)`;

        slides.forEach((slide, slideIndex) => {
          slide.classList.toggle('is-active', slideIndex === index);
        });

        dots.forEach((dot, dotIndex) => {
          dot.classList.toggle('is-active', dotIndex === logicalIndex);
        });

        if (!animate) {
          void track.offsetHeight;
          track.style.transition = 'transform 0.45s ease';
          requestAnimationFrame(() => {
            slideshow.classList.remove('is-resetting');
          });
        }
      };

      const goBy = (step) => {
        if (isTransitioning) return;
        isTransitioning = true;
        index += step;
        logicalIndex = (logicalIndex + step + total) % total;
        update(true);
      };

      const goTo = (newLogicalIndex) => {
        if (isTransitioning) return;
        const normalized = ((newLogicalIndex % total) + total) % total;
        if (normalized === logicalIndex) return;
        const candidates = [normalized, normalized + total, normalized + total * 2];
        let nextIndex = candidates[0];
        let bestDistance = Math.abs(candidates[0] - index);
        for (let i = 1; i < candidates.length; i++) {
          const distance = Math.abs(candidates[i] - index);
          if (distance < bestDistance) {
            bestDistance = distance;
            nextIndex = candidates[i];
          }
        }
        logicalIndex = normalized;
        index = nextIndex;
        isTransitioning = true;
        update(true);
      };

      const goToRendered = (renderedIndex) => {
        if (isTransitioning || renderedIndex === index) return;
        index = renderedIndex;
        logicalIndex = getLogicalIndexFromRendered(renderedIndex);
        isTransitioning = true;
        update(true);
      };

      const startAutoplay = () => {
        if (!shouldAutoplayNow()) return;
        stopAutoplay();
        timer = window.setInterval(() => {
          goBy(1);
        }, interval);
      };

      const stopAutoplay = () => {
        if (!timer) return;
        window.clearInterval(timer);
        timer = null;
      };

      if (prev) {
        prev.addEventListener('click', () => {
          goBy(-1);
          startAutoplay();
        });
      }

      if (next) {
        next.addEventListener('click', () => {
          goBy(1);
          startAutoplay();
        });
      }

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const target = Number(dot.dataset.index);
          goTo(target);
          startAutoplay();
        });
      });

      if (canHoverActivate) {
        slides.forEach((slide, renderedIndex) => {
          slide.addEventListener('mouseenter', () => {
            goToRendered(renderedIndex);
            stopAutoplay();
          });
        });
      }

      let pointerStartX = 0;
      let pointerStartY = 0;
      let isPointerDown = false;
      let didSwipe = false;

      const handlePointerDown = (event) => {
        if (event.pointerType == 'mouse' && !canHoverActivate) return;
        isPointerDown = true;
        didSwipe = false;
        pointerStartX = event.clientX;
        pointerStartY = event.clientY;
      };

      const handlePointerMove = (event) => {
        if (!isPointerDown) return;
        const deltaX = event.clientX - pointerStartX;
        const deltaY = event.clientY - pointerStartY;
        if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 12) {
          didSwipe = true;
        }
      };

      const handlePointerUp = (event) => {
        if (!isPointerDown) return;
        isPointerDown = false;
        if (!didSwipe) return;
        const deltaX = event.clientX - pointerStartX;
        if (Math.abs(deltaX) < 40) return;
        if (deltaX < 0) {
          goBy(1);
        } else {
          goBy(-1);
        }
        startAutoplay();
      };

      viewport.addEventListener('pointerdown', handlePointerDown);
      viewport.addEventListener('pointermove', handlePointerMove);
      viewport.addEventListener('pointerup', handlePointerUp);
      viewport.addEventListener('pointercancel', handlePointerUp);

      slideshow.addEventListener('mouseenter', stopAutoplay);
      slideshow.addEventListener('mouseleave', startAutoplay);
      slideshow.addEventListener('focusin', stopAutoplay);
      slideshow.addEventListener('focusout', startAutoplay);
      track.addEventListener('transitionend', (event) => {
        if (event.target !== track || event.propertyName !== 'transform') return;
        if (index < total || index >= total * 2) {
          index = total + logicalIndex;
          update(false);
        }
        isTransitioning = false;
      });

      window.addEventListener('resize', () => {
        isMobile = window.innerWidth <= 1000;
        if (shouldAutoplayNow()) {
          startAutoplay();
        } else {
          stopAutoplay();
        }
        update(false);
      });

      update(false);
      startAutoplay();
    });

    const variantRows = document.querySelectorAll('.right_menus_product_variant');
    variantRows.forEach((row) => {
      const scroller = row.querySelector('.right_menus_product_variant_values');
      const prevButton = row.querySelector('.right_menus_product_variant_nav.is-prev');
      const nextButton = row.querySelector('.right_menus_product_variant_nav.is-next');
      if (!scroller || !prevButton || !nextButton) return;

      const updateScrollableState = () => {
        const hasOverflow = scroller.scrollWidth > scroller.clientWidth + 2;
        row.classList.toggle('is-scrollable', hasOverflow);
      };

      prevButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        scroller.scrollBy({ left: -120, behavior: 'smooth' });
      });

      nextButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        scroller.scrollBy({ left: 120, behavior: 'smooth' });
      });

      updateScrollableState();
      window.addEventListener('resize', updateScrollableState);
    });

    const variantChips = document.querySelectorAll('.right_menus_product_variant_chip');
    variantChips.forEach((chip) => {
      const activateChip = () => {
        const productCard = chip.closest('.right_menus_product');
        if (!productCard) return;

        const image = productCard.querySelector('.right_menus_product_main_image');
        if (!image) return;

        const newImage = chip.dataset.variantImage;
        if (newImage) {
          image.src = newImage;
          image.srcset = '';
        }

        const siblings = chip
          .closest('.right_menus_product_variant_values')
          ?.querySelectorAll('.right_menus_product_variant_chip');
        siblings?.forEach((item) => item.classList.remove('is-active'));
        chip.classList.add('is-active');
      };

      chip.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        activateChip();
      });

      chip.addEventListener('keydown', (event) => {
        if (event.key == 'Enter' || event.key == ' ') {
          event.preventDefault();
          event.stopPropagation();
          activateChip();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const hubs = document.querySelectorAll('[data-faq-hub]');
    if (!hubs.length) return;

    hubs.forEach((hub) => {
      const input = hub.querySelector('[data-faq-search-input]');
      const groups = hub.querySelectorAll('[data-faq-group]');
      const items = hub.querySelectorAll('[data-faq-item]');
      const noResults = hub.querySelector('[data-faq-no-results]');

      if (!input || !groups.length || !items.length || !noResults) return;

      const filterItems = () => {
        const keyword = (input.value || '').trim().toLowerCase();
        let visibleCount = 0;

        items.forEach((item) => {
          const text = item.getAttribute('data-faq-text') || '';
          const show = keyword === '' || text.includes(keyword);
          item.hidden = !show;
          if (show) visibleCount += 1;
        });

        groups.forEach((group) => {
          const groupItems = group.querySelectorAll('[data-faq-item]');
          if (!groupItems.length) return;
          let visibleInGroup = 0;
          groupItems.forEach((item) => {
            if (!item.hidden) visibleInGroup += 1;
          });
          group.hidden = visibleInGroup === 0;
        });

        noResults.hidden = visibleCount !== 0;
      };

      input.addEventListener('input', filterItems);
      filterItems();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const initProductPage = (section) => {
      if (!section || section.dataset.productPageInitialized === 'true') return;
      section.dataset.productPageInitialized = 'true';

      const mainMedia = section.querySelector('.product-gallery__main-media');
      let mainImage = section.querySelector('.product-gallery__main-image');
      const thumbs = section.querySelectorAll('.product-gallery__thumb');

      const setActiveThumb = (target) => {
        thumbs.forEach((thumb) => thumb.classList.remove('is-active'));
        if (target) target.classList.add('is-active');
      };

      const activateThumbByUrl = (url) => {
        if (!url || thumbs.length === 0) return;
        const matchedThumb = Array.from(thumbs).find((thumb) => thumb.getAttribute('data-image-url') === url);
        if (matchedThumb) setActiveThumb(matchedThumb);
      };

      const switchMainImage = (url, altText) => {
        if (!mainMedia || !mainImage || !url) return;
        if (mainImage.getAttribute('src') === url || mainImage.getAttribute('data-current-image') === url) return;

        mainMedia.classList.add('is-switching');
        const preload = new Image();
        preload.onload = () => {
          const nextImage = new Image();
          nextImage.className = mainImage.className;
          nextImage.setAttribute('loading', 'eager');
          nextImage.setAttribute('src', url);
          nextImage.setAttribute('data-current-image', url);
          if (altText) {
            nextImage.setAttribute('alt', altText);
          } else {
            nextImage.setAttribute('alt', mainImage.getAttribute('alt') || '');
          }

          mainImage.replaceWith(nextImage);
          mainImage = nextImage;
          requestAnimationFrame(() => {
            mainMedia.classList.remove('is-switching');
          });
        };
        preload.src = url;
      };

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const url = thumb.getAttribute('data-image-url');
          const altText = thumb.getAttribute('data-image-alt');
          switchMainImage(url, altText);
          setActiveThumb(thumb);
        });
      });

      const variantInput = section.querySelector('.product-detail__variant-id');
      const price = section.querySelector('[data-product-price]');
      const sku = section.querySelector('[data-product-sku]');
      const variantButtons = section.querySelectorAll('.product-variants__button');
      const qtyInput = section.querySelector('.product-detail__qty-input');
      const submitButton = section.querySelector('.product-detail__submit');
      const productForm = section.querySelector('.product-detail__form');
      const policyOpenButtons = section.querySelectorAll('[data-policy-modal-open]');
      const policyModals = section.querySelectorAll('[data-policy-modal]');
      const initialAvailability = section.getAttribute('data-current-variant-available') === 'true';
      let isSubmitting = false;
      let activeModal = null;

      const updatePurchaseState = (isAvailable) => {
        if (!submitButton) return;
        submitButton.disabled = !isAvailable;
        submitButton.textContent = isAvailable ? 'カートに入れる' : '売り切れ';
        if (qtyInput) {
          qtyInput.disabled = !isAvailable;
          qtyInput.readOnly = !isAvailable;
          qtyInput.setAttribute('aria-disabled', String(!isAvailable));
          if (isAvailable) {
            qtyInput.removeAttribute('tabindex');
          } else {
            qtyInput.setAttribute('tabindex', '-1');
          }
        }
      };

      updatePurchaseState(initialAvailability);

      const setActiveVariant = (button) => {
        variantButtons.forEach((item) => item.classList.remove('is-active'));
        if (button) button.classList.add('is-active');
      };

      variantButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (button.hasAttribute('disabled')) return;

          const variantId = button.getAttribute('data-variant-id');
          const variantPrice = button.getAttribute('data-variant-price');
          const variantSku = button.getAttribute('data-variant-sku');
          const variantAvailable = button.getAttribute('data-variant-available') === 'true';
          const variantImageUrl = button.getAttribute('data-variant-image-url');
          const variantImageAlt = button.getAttribute('data-variant-image-alt');

          if (variantInput && variantId) variantInput.value = variantId;
          if (price && variantPrice) price.textContent = variantPrice;
          if (sku) sku.textContent = variantSku || '-';
          updatePurchaseState(variantAvailable);
          if (variantImageUrl) {
            switchMainImage(variantImageUrl, variantImageAlt);
            activateThumbByUrl(variantImageUrl);
          }

          setActiveVariant(button);
        });
      });

      if (productForm) {
        productForm.addEventListener('submit', async (event) => {
          if (!window.fetch) return;
          if (isSubmitting) {
            event.preventDefault();
            return;
          }

          event.preventDefault();
          isSubmitting = true;

          const previousLabel = submitButton ? submitButton.textContent : '';
          if (submitButton) {
            submitButton.disabled = true;
            submitButton.textContent = '追加中...';
          }

          try {
            const addResponse = await fetch('/cart/add.js', {
              method: 'POST',
              body: new FormData(productForm),
              headers: {
                Accept: 'application/json',
              },
            });

            if (!addResponse.ok) {
              throw new Error('Failed to add item to cart');
            }

            document.dispatchEvent(new CustomEvent('cart:open'));
          } catch (error) {
            window.location.href = '/cart';
          } finally {
            isSubmitting = false;
            if (submitButton) {
              submitButton.disabled = false;
              submitButton.textContent = previousLabel;
            }
          }
        });
      }

      if (policyOpenButtons.length > 0 && policyModals.length > 0) {
        const closePolicyModal = (modal) => {
          if (!modal) return;
          modal.hidden = true;
          modal.setAttribute('aria-hidden', 'true');
          if (activeModal === modal) activeModal = null;
          document.body.classList.remove('product-policy-modal-open');
        };

        const openPolicyModal = (modal) => {
          if (!modal) return;
          modal.hidden = false;
          modal.setAttribute('aria-hidden', 'false');
          activeModal = modal;
          document.body.classList.add('product-policy-modal-open');
        };

        policyOpenButtons.forEach((button) => {
          button.addEventListener('click', () => {
            const targetId = button.getAttribute('data-policy-modal-open');
            if (!targetId) return;
            const targetModal = section.querySelector(`#${targetId}`);
            if (!targetModal) return;
            openPolicyModal(targetModal);
          });
        });

        policyModals.forEach((modal) => {
          modal.addEventListener('click', (event) => {
            if (event.target.hasAttribute('data-policy-modal-overlay')) {
              closePolicyModal(modal);
            }
          });

          const closeButton = modal.querySelector('[data-policy-modal-close]');
          if (closeButton) {
            closeButton.addEventListener('click', () => {
              closePolicyModal(modal);
            });
          }
        });

        document.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          if (!activeModal) return;
          closePolicyModal(activeModal);
        });
      }
    };

    document.querySelectorAll('[data-product-page]').forEach((section) => {
      initProductPage(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
